export default __webpack_public_path__ + "static/media/E90BFE88-9094-489A-86A6-95854AFA46DF.6d295ed1.jpeg";